export default __webpack_public_path__ + "static/media/111-archives.6cc02430.svg";